<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48"><title>mastercard</title><g class="nc-icon-wrapper"><rect x="1" y="7" width="46" height="34" rx="3" ry="3" fill="#243747" /> <circle cx="19" cy="24" r="8" fill="#e61c24" /> <circle cx="28.934" cy="24" r="8" fill="#f99f1b" /> <path d="M23.967,17.736h0a7.985,7.985,0,0,0,0,12.528h0a7.985,7.985,0,0,0,0-12.528Z" fill="#f26622" /></g></svg>
</template>
<script>
	export default {
		name: "icon-mastercard"
	}
</script>